import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  const painPoints = ['Empezás con ganas, pero a los pocos días lo dejás', "Te cansás en minutos y pensás 'esto no es para mí'", 'No tenés tiempo y siempre lo postergás', 'Te da vergüenza porque sentís que estás fuera de estado', 'No sabés qué hacer exactamente y terminás improvisando', 'Arrancás fuerte… y a la semana estás agotado o lesionado'];
  return <section className="bg-light py-20 md:py-32" data-id="element-152">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="text-center mb-16" data-id="element-155">
            <div className="inline-flex items-center justify-center p-3 bg-red-100 text-red-600 rounded-full mb-6" data-id="element-156">
              <AlertTriangle className="w-8 h-8" data-id="element-157" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-6" data-id="element-158">
              ¿Sentís que tu cuerpo no arranca… o peor, que siempre volvés al
              mismo punto?
            </h2>
            <p className="text-xl text-gray-600 font-medium" data-id="element-159">
              Querés empezar a correr… pero:
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-16" data-id="element-160">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-161">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex items-start gap-4" data-id="element-162">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-163" />
                <p className="text-gray-700 font-medium" data-id="element-164">{point}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-165">
          <div className="bg-dark text-white p-8 md:p-10 rounded-2xl text-center shadow-xl relative overflow-hidden" data-id="element-166">
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-167"></div>

            <p className="text-xl md:text-2xl font-bold mb-6" data-id="element-168">
              Y lo peor no es eso. <br className="hidden md:block" data-id="element-169" />
              <span className="text-primary" data-id="element-170">
                Es la sensación de empezar otra vez… y volver a abandonar.
              </span>
            </p>

            <p className="text-gray-300 mb-8 text-lg" data-id="element-171">
              Sentís que te falta disciplina, que no sos constante, o
              simplemente que "no podés sostener nada".
            </p>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm border border-white/10" data-id="element-172">
              <p className="text-xl font-bold" data-id="element-173">
                Pero no es tu culpa. <br data-id="element-174" />
                Nunca tuviste un{' '}
                <span className="text-primary" data-id="element-175">sistema diseñado</span> para
                alguien que empieza desde cero.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}